import { useState } from "react";
import AdmissionsDashboard from "../components/stats/AdmissionsDashboard";
import ExtractionDashboard from "../components/stats/ExtractionDashboard";

const TABS = [
  { id: "extraction", label: "Extraction" },
  { id: "admissions", label: "Admissions" },
];

const Stats = () => {
  const [tab, setTab] = useState("extraction");

  return (
    <div className="h-full w-full overflow-y-auto bg-gray-50">
      <div className="p-6">
        <div className="mb-5">
          <h1 className="flex items-center gap-2 text-2xl font-semibold tracking-tight text-gray-900">
            Tableau de bord
            <span className="rounded-md bg-gray-100 px-1.5 py-0.5 text-xs font-medium text-gray-500">beta</span>
          </h1>
          <p className="mt-1 text-sm text-gray-500">Suivi des admissions et de l'extraction</p>
        </div>

        <div className="mb-6 inline-flex items-center gap-0.5 rounded-lg bg-gray-100 p-0.5">
          {TABS.map((t) => (
            <button
              key={t.id}
              type="button"
              onClick={() => setTab(t.id)}
              className={`rounded-md px-3 py-1 text-sm font-medium transition-colors ${tab === t.id ? "bg-white text-gray-900 shadow-sm" : "text-gray-500 hover:text-gray-800"}`}
            >
              {t.label}
            </button>
          ))}
        </div>

        {tab === "admissions" && <AdmissionsDashboard />}
        {tab === "extraction" && <ExtractionDashboard />}
      </div>
    </div>
  );
};

export default Stats;
